"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAllPipelineData = exports.formatPipelineEdgesData = exports.formatPipelineNodesData = exports.getNodeStyle = exports.getNodeType = exports.NODE_TYPES = void 0;
var NODE_TYPES;
(function (NODE_TYPES) {
    NODE_TYPES["InputNode"] = "inputNode";
    NODE_TYPES["OutputNode"] = "outputNode";
    NODE_TYPES["ModuleNode"] = "moduleNode";
    NODE_TYPES["ProcessNode"] = "processNode";
})(NODE_TYPES || (exports.NODE_TYPES = NODE_TYPES = {}));
const getNumbers = (s) => { var _a, _b; return (_b = (_a = s === null || s === void 0 ? void 0 : s.match(/\d+$/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : ""; };
const getNodeType = (type) => {
    const first = type.charAt(0);
    if (type === "inPro") {
        return NODE_TYPES.InputNode;
    }
    else if (type === "outPro") {
        return NODE_TYPES.OutputNode;
    }
    else if (first === "p") {
        return NODE_TYPES.ModuleNode;
    }
    else {
        return NODE_TYPES.ProcessNode;
    }
};
exports.getNodeType = getNodeType;
const getNodeStyle = (type) => {
    switch (type) {
        case "inputNode":
            return "input";
        case "outputNode":
            return "output";
        case "moduleNode":
            return "module";
        default:
            return "process";
    }
};
exports.getNodeStyle = getNodeStyle;
const formatPipelineNodesData = (pipeline) => {
    const nodes = typeof pipeline.nodes === "string"
        ? JSON.parse(pipeline.nodes)
        : pipeline.nodes;
    const hydrated = [];
    if (Object.keys(nodes).length === 0) {
        return hydrated;
    }
    if (nodes) {
        for (const property in nodes) {
            const result = [...nodes[property], property];
            hydrated.push(result);
        }
    }
    if (hydrated.length) {
        return hydrated.map((a) => {
            const type = (0, exports.getNodeType)(a[2]);
            const dataId = a[2].charAt(0) === "p" ? "pipelineId" : "processId";
            const id = a[2].charAt(0) === "p" ? a[2].replace(/p/g, "") : a[2];
            return {
                id: a[5].replace(/\D/g, ""),
                name: a[3],
                type,
                data: {
                    label: a[3],
                    type,
                    className: (0, exports.getNodeStyle)(type),
                    [dataId]: id,
                    settings: a[4],
                },
                position: { x: a[0], y: a[1] },
            };
        });
    }
    return [];
};
exports.formatPipelineNodesData = formatPipelineNodesData;
const formatPipelineEdgesData = ({ edges }) => {
    if ((edges === null || edges === void 0 ? void 0 : edges.length) === 0) {
        return [];
    }
    return edges.map((e) => {
        const [firstPart, secondPart] = e.split("_");
        const firstChars = firstPart.split("-")[0];
        const secondChars = secondPart.split("-")[1];
        const firstChunk = firstPart.split("-", 3).slice(0, 2).join("-");
        const firstSplit = firstPart.split("-");
        const secondSplit = secondPart.split("-");
        const commonFields = {
            id: `${firstPart}_${secondPart}`,
            type: "deleteButtonEdge",
        };
        switch (firstChunk) {
            case "i-outPro":
                return Object.assign(Object.assign({}, commonFields), { node: firstSplit[4], source: getNumbers(secondPart), target: getNumbers(firstPart), sourceHandle: secondPart, targetHandle: firstPart });
            case "o-inPro":
                return Object.assign(Object.assign({}, commonFields), { node: firstSplit[4], source: getNumbers(firstPart), target: getNumbers(secondPart), sourceHandle: firstPart, targetHandle: secondPart });
        }
        switch (firstChars) {
            case "o":
                return Object.assign(Object.assign({}, commonFields), { node: firstSplit[4], source: getNumbers(firstPart), target: getNumbers(secondPart), sourceHandle: firstPart, targetHandle: secondPart });
            case "i":
                return Object.assign(Object.assign({}, commonFields), { node: firstSplit[4], source: getNumbers(secondPart), target: getNumbers(firstPart), sourceHandle: secondPart, targetHandle: firstPart });
            case "po":
                return Object.assign(Object.assign({}, commonFields), { node: firstSplit[4], pipelineId: parseInt(firstSplit[1]), processId: parseInt(firstSplit[3]), source: getNumbers(firstPart), target: getNumbers(secondPart), sourceHandle: firstPart, targetHandle: secondPart });
            case "pi":
                return Object.assign(Object.assign({}, commonFields), { node: firstSplit[4], pipelineId: parseInt(firstSplit[1]), processId: parseInt(firstSplit[3]), source: getNumbers(secondPart), target: getNumbers(firstPart), sourceHandle: secondPart, targetHandle: firstPart });
        }
        switch (secondChars) {
            case "o":
                return Object.assign(Object.assign({}, commonFields), { node: secondSplit[4], parameterId: parseInt(secondSplit[3]), source: getNumbers(firstPart), target: getNumbers(secondPart), sourceHandle: secondPart, targetHandle: firstPart });
            case "i":
                return Object.assign(Object.assign({}, commonFields), { node: secondSplit[4], parameterId: parseInt(secondSplit[3]), source: getNumbers(secondPart), target: getNumbers(firstPart), sourceHandle: firstPart, targetHandle: secondPart });
            case "pi":
                return Object.assign(Object.assign({}, commonFields), { node: secondSplit[4], pipelineId: parseInt(secondSplit[1]), processId: parseInt(secondSplit[3]), source: getNumbers(secondPart), target: getNumbers(firstPart), sourceHandle: firstPart, targetHandle: secondPart });
            case "po":
                return Object.assign(Object.assign({}, commonFields), { node: secondSplit[4], pipelineId: parseInt(secondSplit[1]), processId: parseInt(secondSplit[3]), source: getNumbers(firstPart), target: getNumbers(secondPart), sourceHandle: secondPart, targetHandle: firstPart });
        }
        return {};
    });
};
exports.formatPipelineEdgesData = formatPipelineEdgesData;
const formatAllPipelineData = (pipeline) => {
    const nodesFormatted = (0, exports.formatPipelineNodesData)(pipeline);
    const edges = typeof pipeline.edges === "string"
        ? JSON.parse(pipeline.edges.replace(/'/g, '"'))
        : pipeline.edges;
    const edgesFormatted = (0, exports.formatPipelineEdgesData)(edges);
    return {
        nodesFormatted,
        edgesFormatted,
    };
};
exports.formatAllPipelineData = formatAllPipelineData;
